import React from 'react'

import CenteredLoader from '../../components/view/CenteredLoader'

export const Modal = props => (
  <div className={props.classes.wrap}>
    <div className={props.classes.modal}>
      {props.children}
      {props.isLoading && (
        <div className={props.classes.loader}>
          <CenteredLoader position={'relative'} size={50} />
        </div>
      )}
    </div>
  </div>
)
